import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { User } from '@/modules/user/models/User';

export class MeetingUser extends BaseEntityModel {
  id?: number;
  meetingId?: number;
  userId?: number;
  userUuid?: string;
  isInvited?: boolean;
  hasAttended?: boolean;
  user?: Relationship<User> | null;

  constructor(model: Partial<MeetingUser> = {}) {
    super(model);

    this.id = model.id;
    this.meetingId = model.meetingId;
    this.userId = model.userId;
    this.userUuid = model.userUuid;
    this.isInvited = model.isInvited;
    this.hasAttended = model.hasAttended;

    // @ts-ignore
    this.user = User.mapModel(model.user);
  }
}
